import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DashboardLayout } from '@/components/layout';
import { QRCodeGenerator } from '@/components/qr';
import type { Platform } from '@/types';

const QRCodes = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const platform = (searchParams.get('platform') || 'generic') as Platform;
  const checkNeeded = searchParams.get('checkNeeded') !== 'false';

  return (
    <DashboardLayout>
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-dark-800 dark:text-white mb-2">{t('qr.title')}</h1>
        <p className="text-gray-500 dark:text-gray-400">
          {t('qr.subtitle')}
        </p>
      </div>

      <QRCodeGenerator
        initialCode={code || undefined}
        platform={platform}
        checkNeeded={checkNeeded}
      />
    </DashboardLayout>
  );
};

export default QRCodes;
